import Polyglot from 'node-polyglot';
import {getBrowserCookie} from './helper';
import Constants from './constants';


function GetUserDefaultLocale() {
  const lang = navigator.userLanguage || navigator.language || navigator.browserLanguage;
  let language = Constants.Languages.English;
  if (Constants.Languages.English === lang.toLowerCase()) {
    language = Constants.Languages.English;
  } else if (Constants.Languages.Chinese === lang.toLowerCase()) {
    language = Constants.Languages.Chinese;
  } else if (Constants.Languages.Japanese === lang.toLowerCase()) {
    language = Constants.Languages.Japanese;
  }
  return language;
}

function GetPreferredLanguage() {
  const preferredLanguage = getBrowserCookie(Constants.LanguagePreference) ? getBrowserCookie(Constants.LanguagePreference) : GetUserDefaultLocale();
  return preferredLanguage;
}

const languagePreference = GetPreferredLanguage();

const polyglot = new Polyglot({ locale: languagePreference });

const translations = require(`./translations/${polyglot.locale()}.json`);
polyglot.extend(translations);

/**
 * This function is simply a shorthand wrapper for calling polyglot.t(). It is used as L()
 * to keep the function name small, since this will be called all throughout the application.
 *
 * @param {The string to translate} string
 * @param {Interpolation of any values that need to be included in the string} interpolation
 */


// This does not export default, so that L is required as the function name where used.
// Also so that this can be extended to potentially include some other helper functions in the future.
export default {
  L(string, interpolation) {
    return polyglot.t(string, interpolation);
  },
  GetUserDefaultLocale() {
    const lang = navigator.userLanguage || navigator.language || navigator.browserLanguage;
    let language = Constants.Languages.English;
    if (Constants.Languages.English === lang.toLowerCase()) {
      language = Constants.Languages.English;
    } else if (Constants.Languages.Chinese === lang.toLowerCase()) {
      language = Constants.Languages.Chinese;
    } else if (Constants.Languages.Japanese === lang.toLowerCase()) {
      language = Constants.Languages.Japanese;
    }
    return language;
  },

  GetPreferredLanguage() {
    const preferredLanguage = getBrowserCookie(Constants.LanguagePreference) ? getBrowserCookie(Constants.LanguagePreference) : GetUserDefaultLocale();
    return preferredLanguage;
  },
};
